
import Vue from 'vue'

const SET_LIST = (state, obj) => {
  state.list = obj.data
}

const REMOVE_ALL_BANCOS_USUARIO = (state) => {
  state.list = []
}

const SET_ONE = (state, obj) => {
  const { index, contasBancariasUsuarios } = obj
  if (index > -1) {
    Vue.set(state.list, index, contasBancariasUsuarios)
  } else {
    state.list.unshift(contasBancariasUsuarios)
  }
}

const REMOVE_ONE = (state, obj) => {
  state.list.splice(obj.index, 1)
}

export default {
  SET_LIST,
  SET_ONE,
  REMOVE_ONE,
  REMOVE_ALL_BANCOS_USUARIO
}



// WEBPACK FOOTER //
// ./src/features/admin/contasBancariasUsuarios/store/mutations.js